<template>
  <div class="company-switcher" v-click-outside="hideCompaniesSwitcher">
    <div
      class="company-switcher__header"
      @click="isCompaniesSwitcherOpened = !isCompaniesSwitcherOpened"
    >
      <div class="company-switcher__selected-icon">
        <svg
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="41" height="41" rx="8" fill="#E9F2FF" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.3443 13.022C13.3443 11.7011 14.4151 10.6304 15.7359 10.6304H25.3026C26.6235 10.6304 27.6943 11.7011 27.6943 13.022V27.372C28.3547 27.372 28.8901 27.9074 28.8901 28.5679C28.8901 29.2283 28.3547 29.7637 27.6943 29.7637H24.1068C23.4463 29.7637 22.9109 29.2283 22.9109 28.5679V26.1762C22.9109 25.5157 22.3756 24.9804 21.7151 24.9804H19.3234C18.663 24.9804 18.1276 25.5157 18.1276 26.1762V28.5679C18.1276 29.2283 17.5922 29.7637 16.9318 29.7637H13.3443C12.6838 29.7637 12.1484 29.2283 12.1484 28.5679C12.1484 27.9074 12.6838 27.372 13.3443 27.372V13.022ZM16.9318 14.2179H19.3234V16.6095H16.9318V14.2179ZM19.3234 19.0012H16.9318V21.3929H19.3234V19.0012ZM21.7151 14.2179H24.1068V16.6095H21.7151V14.2179ZM24.1068 19.0012H21.7151V21.3929H24.1068V19.0012Z"
            fill="#64748B"
          />
        </svg>
      </div>
      <div class="company-switcher__selected-name">
        {{ selectedCompanyItem.CompanyName }}
      </div>
      <div
        class="company-switcher__selected-caret"
        :class="{ active: isCompaniesSwitcherOpened }"
      >
        <arrow-button
          class="company-switcher__selected-caret-button"
        ></arrow-button>
      </div>
    </div>
    <div class="company-switcher__list" v-if="isCompaniesSwitcherOpened">
      <div class="company-switcher__item" @click="goToDashboard">
        <div class="company-switcher__item-icon">
          <svg
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.5 0C7.5 0 2.8605 4.15333 0.26775 6.40267C0.1155 6.54578 0 6.75422 0 7C0 7.43011 0.33525 7.77778 0.75 7.77778H2.25V13.2222C2.25 13.6523 2.58525 14 3 14H5.25C5.66475 14 6 13.6516 6 13.2222V10.1111H9V13.2222C9 13.6516 9.33525 14 9.75 14H12C12.4148 14 12.75 13.6523 12.75 13.2222V7.77778H14.25C14.6648 7.77778 15 7.43011 15 7C15 6.75422 14.8845 6.54578 14.7128 6.40267C12.138 4.15333 7.5 0 7.5 0Z"
              fill="#64748B"
            />
          </svg>
        </div>
        <div class="company-switcher__item-name">
          {{ $t('company_switcher.all_companies') }}
        </div>
        <div class="company-switcher__item-arrow">
          <svg
            width="5"
            height="8"
            viewBox="0 0 5 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.52433 3.64913L1.0016 0.126462C0.920118 0.0449215 0.811354 0 0.695382 0C0.57941 0 0.470646 0.0449215 0.38917 0.126462L0.129745 0.385823C-0.0390649 0.554826 -0.0390649 0.829503 0.129745 0.998248L3.08787 3.95637L0.126462 6.91778C0.0449859 6.99932 0 7.10802 0 7.22393C0 7.33997 0.0449859 7.44867 0.126462 7.53027L0.385887 7.78957C0.467428 7.87111 0.576128 7.91603 0.6921 7.91603C0.808072 7.91603 0.916836 7.87111 0.998313 7.78957L4.52433 4.26368C4.606 4.18188 4.65086 4.07267 4.6506 3.95657C4.65086 3.84002 4.606 3.73087 4.52433 3.64913Z"
              fill="#E0E6F2"
            />
          </svg>
        </div>
      </div>
      <div
        class="company-switcher__item"
        @click="goToCompany(company)"
        :class="{ selected: parseInt(selectedCompanyItem.ID) === company.ID }"
        v-for="company in companies"
        :key="`company-item-${company.ID}`"
      >
        <div class="company-switcher__item-icon">
          <svg
            width="41"
            height="41"
            viewBox="0 0 41 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="41" height="41" rx="8" fill="#E9F2FF" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.3443 13.022C13.3443 11.7011 14.4151 10.6304 15.7359 10.6304H25.3026C26.6235 10.6304 27.6943 11.7011 27.6943 13.022V27.372C28.3547 27.372 28.8901 27.9074 28.8901 28.5679C28.8901 29.2283 28.3547 29.7637 27.6943 29.7637H24.1068C23.4463 29.7637 22.9109 29.2283 22.9109 28.5679V26.1762C22.9109 25.5157 22.3756 24.9804 21.7151 24.9804H19.3234C18.663 24.9804 18.1276 25.5157 18.1276 26.1762V28.5679C18.1276 29.2283 17.5922 29.7637 16.9318 29.7637H13.3443C12.6838 29.7637 12.1484 29.2283 12.1484 28.5679C12.1484 27.9074 12.6838 27.372 13.3443 27.372V13.022ZM16.9318 14.2179H19.3234V16.6095H16.9318V14.2179ZM19.3234 19.0012H16.9318V21.3929H19.3234V19.0012ZM21.7151 14.2179H24.1068V16.6095H21.7151V14.2179ZM24.1068 19.0012H21.7151V21.3929H24.1068V19.0012Z"
              fill="#64748B"
            />
          </svg>
        </div>
        <div class="company-switcher__item-name">
          {{ company.CompanyName }}
        </div>
        <div class="company-switcher__item-arrow">
          <svg
            width="5"
            height="8"
            viewBox="0 0 5 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.52433 3.64913L1.0016 0.126462C0.920118 0.0449215 0.811354 0 0.695382 0C0.57941 0 0.470646 0.0449215 0.38917 0.126462L0.129745 0.385823C-0.0390649 0.554826 -0.0390649 0.829503 0.129745 0.998248L3.08787 3.95637L0.126462 6.91778C0.0449859 6.99932 0 7.10802 0 7.22393C0 7.33997 0.0449859 7.44867 0.126462 7.53027L0.385887 7.78957C0.467428 7.87111 0.576128 7.91603 0.6921 7.91603C0.808072 7.91603 0.916836 7.87111 0.998313 7.78957L4.52433 4.26368C4.606 4.18188 4.65086 4.07267 4.6506 3.95657C4.65086 3.84002 4.606 3.73087 4.52433 3.64913Z"
              fill="#E0E6F2"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CompaniesApi } from '@js-app/office/api/companies-api'
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import { mapState } from 'vuex'
import { SET_ACTIVE_COMPANY } from '@vue-app/store/const/actions-types'
import responsiveMixin from '@vue-app/mixins/responsive-mixin'

import { ROUTES_LIST } from '@js-app/services/helpers/routes/const/routes-list'

export default {
  name: 'HeaderCompanyBlock',
  components: { ArrowButton },
  mixins: [responsiveMixin],
  data() {
    return {
      isCompaniesSwitcherOpened: false,
    }
  },
  async created() {
		await this.$store.dispatch('LOAD_COMPANIES')
  },
  computed: {
    ...mapState(['selectedCompany', 'companies']),
    selectedCompanyItem: function () {
      return (
        this.companies.find(
          (_company) => parseInt(_company.ID) === parseInt(this.selectedCompany)
        ) || {}
      )
    },
  },
  methods: {
    async loadCompanies() {
      let companiesResponse = await CompaniesApi.getCompanies()
      this.companies = companiesResponse.data
    },
    async goToDashboard() {
      await this.$store.dispatch(SET_ACTIVE_COMPANY, null)
      this.isCompaniesSwitcherOpened = false
      await this.$router.push('/cabinet')
    },
    async goToCompany(company) {
      this.hideCompaniesSwitcher()

      if (this.$route.params.billId) {
        const listPath = ROUTES_LIST['bills-list'].replace(
          ':companyId',
          company.ID
        )
        this.$router.push(listPath)
        return
      }

      await this.$router.push({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          id: company.ID,
        },
      })
    },
    hideCompaniesSwitcher() {
      if (!this.isMobile) {
        this.isCompaniesSwitcherOpened = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
@import '@css-app/mixins';
.company-switcher {
  position: relative;
  &__header {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: opacity 0.2s linear;

    &:hover {
      opacity: 0.7;
    }
  }

  &__selected {
    &-icon {
      width: 27px;
      height: 27px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      border-radius: 4px;
      margin-right: 10px;

      svg,
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    &-name {
      font-weight: 600;
      font-size: pxToRem(16);
      line-height: pxToRem(20);
      color: $h2;
      margin-right: 10px;
    }

    &-caret {
      transform: rotate(90deg);
      transition: transform 0.2s linear;

      &.active {
        transform: rotate(-90deg);
      }
    }
  }

  &__list {
    position: absolute;
    top: calc(100% + 13px);
    left: 0;
    min-width: 265px;
    background: #ffffff;
    box-shadow: 0px -5px 60px rgba(120, 140, 184, 0.1);
    border-radius: 22px;
    padding: 8px 25px;
    z-index: 55;
    max-height: 400px;
    overflow-y: scroll;
  }

  .company-switcher__list::-webkit-scrollbar {
    width: 3px;
  }

  .company-switcher__list::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 12px;
  }

  .company-switcher__list::-webkit-scrollbar-track {
    background-color: transparent;
    height: 50%;
  }

  &__item {
    display: flex;
    align-items: center;
    padding: 10px 0 12px;
    border-bottom: 1px solid rgba($stroke, 0.7);
    cursor: pointer;
    transition: opacity 0.2s linear;

    &:hover {
      opacity: 0.7;
    }

    &:last-child {
      border-bottom: 0;
    }

    &.selected & {
      &-name {
        font-weight: 600;
      }
    }

    &-icon {
      width: 27px;
      height: 27px;

      display: flex;
      align-items: center;
      justify-content: center;

      background: #ffffff;
      border-radius: 4px;
      margin-right: 9px;
      flex-shrink: 0;
      flex-grow: 0;

      svg,
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    &-name {
      font-weight: 500;
      font-size: pxToRem(12);
      line-height: pxToRem(15);
      color: $text2;
    }

    &-arrow {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: auto;
    }
  }
}
@media screen and (max-width: 992px) {
  .company-switcher {
    border: 1px solid #e0e6f2;
    border-radius: 22px;
    padding: 15px;
    &__header {
    }

    &__selected {
      &-caret {
        margin-left: auto;
      }
    }

    &__list {
      position: relative;
      padding: 0;
      background-color: transparent;
      box-shadow: unset;
      top: 0;
      margin-top: 16px;
    }

    &__item {
      padding: 10px;
      border-top: 1px solid rgba(#909cb0, 0.1);
      border-bottom: none;
    }
  }
}
</style>
